export default "__VITE_ASSET__BSzZC02$__"